import { Box, Button } from "@mui/material";

 const EntityCTAButtons = ({editableEntityData, handleEntityCTAButtonsClick}) => {

        return (
            <Box display="flex" flexDirection="row" gap={1} mt={1}>
                <Button
                    variant="contained"
                    color="error"
                    fullWidth
                    sx={{ height: 50, backgroundColor: "red", color: 'white', fontSize: 16 }}
                    onClick={() => {
                        handleEntityCTAButtonsClick("delete")
                    }}
                disabled={true}
                >Delete</Button>

                <Button
                    variant="contained"
                    color="error"
                    fullWidth
                    sx={{ height: 50, backgroundColor: "#a855f7", color: 'white', fontSize: 16 }}
                    onClick={() => {
                        handleEntityCTAButtonsClick(editableEntityData?._id?"update":"create")
                    }}
                // disabled={!isValidNew}
                >{editableEntityData?._id?"update":"create"}</Button>
            </Box>
        );
    }

export default EntityCTAButtons;